import { createFileRoute } from "@tanstack/react-router"

import { pageHead } from "@/lib/metadata"
import { UnsubscribeFlow } from "@/components/layout/unsubscribe-frame"

const ID_PATTERN = /^[a-f0-9]{24}$/i

/** Mirrors `app/(site)/waitlist/unsubscribe/page.tsx`. */
function StatusUnsubscribePage() {
  const { id, token, state } = Route.useSearch()

  return (
    <UnsubscribeFlow
      state={state}
      action="/api/status/unsubscribe"
      fields={id && ID_PATTERN.test(id) && token ? { id, token } : null}
      back={{ href: "/status", label: "Back to status" }}
      copy={{
        ask: "Stop incident emails?",
        done: "You’re unsubscribed.",
        doneBody: "No more incident emails will be sent to that address.",
      }}
    />
  )
}

export const Route = createFileRoute("/status/unsubscribe")({
  validateSearch: (
    search: Record<string, unknown>
  ): { id?: string; token?: string; state?: string } => ({
    id: typeof search.id === "string" ? search.id : undefined,
    token: typeof search.token === "string" ? search.token : undefined,
    state: typeof search.state === "string" ? search.state : undefined,
  }),
  head: () =>
    pageHead({
      title: "Stop incident emails",
      description: "Stop receiving Anysola status page incident emails.",
      path: "/status/unsubscribe",
      index: false,
      extraMeta: [{ name: "referrer", content: "no-referrer" }],
    }),
  component: StatusUnsubscribePage,
})
